import {
  NavigationSettingAriResourceOwner,
  NavigationSettingAriResourceType
} from "./chunk-7DCCRIZV.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/navigation/setting/manifest.ts
var navigationSettingAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: NavigationSettingAriResourceOwner,
  resourceType: NavigationSettingAriResourceType,
  resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
  resourceIdSegmentFormats: {
    firstPartyApp: /(assets|confluence|goals|home|jira|mercury|people|studio|teams)/,
    // eslint-disable-line no-useless-escape
    siteId: /[a-zA-Z0-9_\-.]{1,255}/,
    // eslint-disable-line no-useless-escape
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    settingId: /[a-z0-9-]{5,100}/
    // eslint-disable-line no-useless-escape
  }
};

// src/navigation/setting/index.ts
var NavigationSettingAri = class _NavigationSettingAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
  }
  get firstPartyApp() {
    return this._firstPartyApp;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get settingId() {
    return this._settingId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: navigationSettingAriStaticOpts.qualifier,
      platformQualifier: navigationSettingAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: navigationSettingAriStaticOpts.resourceOwner,
      resourceType: navigationSettingAriStaticOpts.resourceType,
      resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
      resourceIdSegmentValues: {
        firstPartyApp: opts.firstPartyApp,
        siteId: opts.siteId,
        activationId: opts.activationId,
        settingId: opts.settingId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, navigationSettingAriStaticOpts);
    return new _NavigationSettingAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, navigationSettingAriStaticOpts);
    return new _NavigationSettingAri(opts);
  }
  getVariables() {
    return {
      firstPartyApp: this.firstPartyApp,
      siteId: this.siteId,
      activationId: this.activationId,
      settingId: this.settingId
    };
  }
};

export {
  NavigationSettingAri
};
